import Repository from '@/libs/axios'

const resource = '/public/order'

const trackingSettingsLogoResource = '/settings/tracking'

export default {
  getOrderTrackingInfo(payload) {
    return Repository.post(`${resource}/tracking-info`, payload)
  },
  getBusinessInfo() {
    return Repository.get('public/business')
  },
  getTrackingPublicSettingsResource(templateId) {
    if (templateId) {
      return Repository.get(`${trackingSettingsLogoResource}?template_id=${encodeURIComponent(templateId)}`)
    }
    return Repository.get(`${trackingSettingsLogoResource}`)
  },
}
